import { cn } from '@/lib/utils';

interface ContentActivityBadgeProps {
  count: number;
  onClick: () => void;
  className?: string;
}

export function ContentActivityBadge({ count, onClick, className }: ContentActivityBadgeProps) {
  if (count <= 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      title="Activity"
      aria-label={`Activity: ${count}`}
      data-testid="content-activity-badge"
      className={cn(
        'text-sm text-muted-foreground hover:text-foreground transition-colors px-1.5 py-0.5 rounded',
        className
      )}
    >
      Activity {count}
    </button>
  );
}
